import { render, staticRenderFns } from "./studentVacationsView.vue?vue&type=template&id=dfb2ee4e&scoped=true&"
import script from "./studentVacationsView.vue?vue&type=script&lang=js&"
export * from "./studentVacationsView.vue?vue&type=script&lang=js&"
import style0 from "./studentVacationsView.vue?vue&type=style&index=0&id=dfb2ee4e&prod&lang=scss&scoped=true&"
import style1 from "./studentVacationsView.vue?vue&type=style&index=1&id=dfb2ee4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb2ee4e",
  null
  
)

export default component.exports